import React from 'react'
import {getJsonFromUrl} from '../utils'
import {connect} from 'react-redux'
import {ShareCardSlide, Page} from '../components'


class ShareCardPage extends React.Component {

    componentWillMount() {
        const {routeParams} = this.props;

        let data = getJsonFromUrl();

        this.sharecardSlide = {
            id: routeParams.target_id,
            type: routeParams.type,
            inviterId: data.inviter_id
        }
    }

    render(){
        const { accountId } = this.props
        return (
            <Page className={"sharecard-slide "}>
                { accountId && <ShareCardSlide sharecardSlide={this.sharecardSlide}/> }
            </Page>
        )
    }
}

ShareCardPage.contextTypes = {
    page: React.PropTypes.object
};

export default connect((state) => ({
    accountId: state.account.id
}))(ShareCardPage)


// WEBPACK FOOTER //
// ./src/pages/ShareCardPage.js